import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { OrganisationSpecificStepsComponent } from './organisations-specific-steps.component';
import { AddOrganisationSpecificStepComponent } from './add-organisation-specific-step/add-organisation-specific-step.component';
import { OrganisationSpecificStepTaskTypesComponent } from './organisation-specific-step-task-types/organisation-specific-step-task-types.component';
import { OrganisationSpecificStepCustomersComponent } from './organisation-specific-step-customers/organisation-specific-step-customers.component';
import { TableModule } from 'primeng/table';
const routes: Routes = [{ path: '', component: OrganisationSpecificStepsComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrganisationsSpecificStepsRoutingModule {}

@NgModule({
  imports: [
    OrganisationsSpecificStepsRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    TableModule,
  ],
  declarations: [
    OrganisationSpecificStepsComponent,
    AddOrganisationSpecificStepComponent,
    OrganisationSpecificStepCustomersComponent,
    OrganisationSpecificStepTaskTypesComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [OrganisationSpecificStepsComponent, OrganisationSpecificStepCustomersComponent],
})
export class OrganisationsSpecificStepsModule {}
